export default __webpack_public_path__ + "static/media/logo-package-tts-vi.76a7cb96.png";